import About from "../components/About";

function Sobre(){
    return (
      <div>
       <About/> 
      </div>
    );
}
export default Sobre